import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { createStyles } from '@material-ui/core/styles';
import { Grid, Dialog, InputAdornment, FormLabel, IconButton } from '@material-ui/core/';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Add, AddCircle, AccessTime } from '@material-ui/icons/';
import Pagination from '@material-ui/lab/Pagination';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
// core components
import Table from '../../../components/Table/Table';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CustomInput from '../../../components/CustomInput/CustomInput';
import Button from '../../../components/CustomButtons/Button';
import ImageDropZone from '../../../components/ImageDropZone';
import { Link } from 'react-router-dom';

const styles = createStyles({
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: 300,
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: 400,
      lineHeight: 1
    }
  }
});

function WorkOrder(props: any) {
  const { classes } = props;

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const FormDialog = (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="create-work-order">Create work order</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={6}>
              <CustomInput
                id="asset-id"
                labelText="Asset ID"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-type"
                labelText="Asset Type"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-location"
                labelText="Asset Location"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="asset-model"
                labelText="Asset Model"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                id="work-description"
                multiline
                rowsMax={4}
                labelText="Work description"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="repeating-schedule"
                labelText="Repeating schedule"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormLabel>Priority </FormLabel>
              <ToggleButtonGroup
                size="small"
                exclusive
                aria-label="text alignment"
              >
                <ToggleButton value="None" aria-label="none">
                  None
                </ToggleButton>
                <ToggleButton value="low" aria-label="low">
                  Low
                </ToggleButton>
                <ToggleButton value="medium" aria-label="medium">
                  Medium
                </ToggleButton>
                <ToggleButton value="high" aria-label="high">
                  High
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="estimate-completion-time"
                labelText="Estimated completion time"
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="work-schedule"
                labelText="Work schedule"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccessTime />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-to"
                labelText="Assigned To"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="assigned-team"
                labelText="Assigned Team"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <ImageDropZone />
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="addtional"
                labelText="Add Additional"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <div>
                <input style={{ display: 'none' }} accept="*" className={classes.input} id="button-additional-file" type="file" />
                <label htmlFor="button-additional-file">
                  <FormLabel style={{ marginRight: "4px" }}>Additional files</FormLabel>
                  <IconButton size="small" color="primary" aria-label="upload picture" component="span">
                    <AddCircle />
                  </IconButton>
                </label>
              </div>
              <div>
                <label htmlFor="additional-task">
                  <FormLabel style={{ marginRight: "4px" }}>Additional tasks</FormLabel>
                  <IconButton size="small" color="primary" aria-label="additional task" component="span">
                    <AddCircle />
                  </IconButton>
                </label>
              </div>
            </Grid>
            <Grid item xs={6}>
              <CustomInput
                id="approver"
                labelText="Approver"
                formControlProps={{
                  fullWidth: true
                }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleClose} color="primary">
          Create Maintain WO
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <Grid container>
              <Grid container item xs={8} alignContent="center">
                <h4 className={classes.cardTitleWhite}>Work Order list</h4>
              </Grid>
              <Grid container item xs={4} justify="flex-end">
                <Button color="secondary">Import</Button>
                <Button color="secondary" onClick={handleOpen}><Add />Create Work Order</Button>
              </Grid>
            </Grid>
          </CardHeader>
          <CardBody>
            <Table
              tableHeaderColor="primary"
              tableHead={['No.', 'Customer', 'Location', 'Asset Type', 'Priority', 'Assigned To', 'WO Raised', 'WO Due by', 'WO Status', 'WO Type']}
              tableData={[
                ['1', <Link to="/saas/asset-maintain/work-order-detail/1">'Dakota Rice'</Link>, 'Niger', 'HVAC', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
                ['2', <Link to="/saas/asset-maintain/work-order-detail/1">'Minerva Hooper'</Link>, 'Curaçao', 'HVAC', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
                ['3', <Link to="/saas/asset-maintain/work-order-detail/1">'Sage Rodriguez'</Link>, 'Netherlands', 'HVAC', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'In progress', 'Electrical'],
                ['4', <Link to="/saas/asset-maintain/work-order-detail/1">'Philip Chaney'</Link>, 'Korea, South', 'HVAC', 'Medium', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
                ['5', <Link to="/saas/asset-maintain/work-order-detail/1">'Doris Greene'</Link>, 'Malawi', 'HVAC', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
                ['6', <Link to="/saas/asset-maintain/work-order-detail/1">'Mason Porter'</Link>, 'Chile', 'HVAC', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
                ['7', <Link to="/saas/asset-maintain/work-order-detail/1">'Sage Rodriguez'</Link>, 'Netherlands', 'Cooling Tower', 'Low', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'In progress', 'Electrical'],
                ['8', <Link to="/saas/asset-maintain/work-order-detail/1">'Philip Chaney'</Link>, 'Korea, South', 'Cooling Tower', 'High', 'Oud-Turnhout', 'Nov 11, 2020 | 17:22', 'Nov 20, 2020 | 13:22', 'Open', 'Electrical'],
                ['9', <Link to="/saas/asset-maintain/work-order-detail/1">'Doris Greene'</Link>, 'Malawi', 'Cooling Tower', 'Low', 'Oud-Turnhout', 'Nov 12, 2020 | 17:22', 'Nov 25, 2020 | 13:22', 'Open', 'Electrical'],
                ['10',<Link to="/saas/asset-maintain/work-order-detail/1">'Mason Porter'</Link>, 'Chile', 'Cooling Tower', 'Low', 'Oud-Turnhout', 'Nov 13, 2020 | 17:22', 'Nov 29, 2020 | 13:22', 'Open', 'Electrical']
              ]}
            />
          </CardBody>
        </Card>
        <div>
          <Pagination count={10} shape="rounded" />
        </div>
        {FormDialog}
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(WorkOrder);
